import React from 'react'
import PropTypes from 'prop-types'
import Translation from '#src/common/components/translation'
import {
  ProductDetailsWrapper,
  PriceDetailsWrapper,
  Container,
  ProductName
} from './styles'

import { ProductImageContainerSmall } from '#src/products/product-details-page/styles'
import ProductImage from '#src/products/product-details-page/components/image'
import Select from './select'
import ProductCalories from '#src/common/components/product-calories'
import { image, product } from '#src/common/propTypes'

const getPrice = price =>
  price?.centAmount > 0 ? (
    price?.localisedPrice
  ) : (
    <Translation id='product.extras.free' />
  )

const CustomisationOption = ({
  productOption,
  placeholderImage,
  onChange,
  multiSelectable,
  type
}) => {
  return (
    <Container data-testid={`customisation-container-${productOption.sku}`}>
      <ProductDetailsWrapper>
        <Select
          isSelected={productOption.isSelected}
          sku={productOption.sku}
          onChange={onChange}
          name={productOption.name}
          multiSelectable={multiSelectable}
          type={type}
          label={productOption.label}
        />
        <ProductImageContainerSmall>
          <ProductImage
            image={productOption.image}
            placeholder={placeholderImage}
            name={productOption.name}
            newUntil={productOption.newUntil}
          />
        </ProductImageContainerSmall>
        <ProductName>
          <p className='text'>{productOption.name}</p>
          <ProductCalories
            classes='text-grey-400 font-medium mt-2 ml-3'
            nutritionalData={productOption.nutritionalData}
          />
        </ProductName>
      </ProductDetailsWrapper>
      <PriceDetailsWrapper>
        <span>{getPrice(productOption.price)}</span>
      </PriceDetailsWrapper>
    </Container>
  )
}

CustomisationOption.propTypes = {
  multiSelectable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  productOption: product.isRequired,
  placeholderImage: image,
  type: PropTypes.string.isRequired
}

CustomisationOption.defaultProps = {
  multiSelectable: false
}

export default CustomisationOption
